import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

import { SharedRespMoreWaysToBrowse } from '../../shared/SharedRespMoreWaysToBrowse/SharedRespMoreWaysToBrowse';
import { SharedMobileMoreWaysToBrowse } from '../../shared/SharedMobileMoreWaysToBrowse/SharedMobileMoreWaysToBrowse';

import { ServerVarsContext } from '../../global/ServerVarsContext/ServerVarsContext';

function BuySharedMoreWaysToBrowseComponent({ internalBuyLinks, viewer }) {
    const { isMobile } = useContext(ServerVarsContext);

    return isMobile ? (
        <SharedMobileMoreWaysToBrowse internalBuyLinks={internalBuyLinks} viewer={viewer} />
    ) : (
        <SharedRespMoreWaysToBrowse internalBuyLinks={internalBuyLinks} />
    );
}

BuySharedMoreWaysToBrowseComponent.propTypes = {
    viewer: PropTypes.object.isRequired,
    internalBuyLinks: PropTypes.array,
};

export const BuySharedMoreWaysToBrowse = createFragmentContainer(
    BuySharedMoreWaysToBrowseComponent,
    {
        viewer: graphql`
            fragment BuySharedMoreWaysToBrowse_viewer on Viewer {
                ...SharedMobileMoreWaysToBrowse_viewer
            }
        `,
        internalBuyLinks: graphql`
            fragment BuySharedMoreWaysToBrowse_internalBuyLinks on InternalBuyLinkType
                @relay(plural: true) {
                ...SharedRespMoreWaysToBrowse_internalBuyLinks
                ...SharedMobileMoreWaysToBrowse_internalBuyLinks
            }
        `,
    }
);
